import axios from "../../lib/axiosInstance";

export function fetchAllProjects(params = {}) {
  if (params.page && typeof params.page !== "number") {
    params.page = parseInt(params.page, 10) || 1;
  }
  // URLSearchParams stringifies undefined/null into the literal "undefined",
  // which the API then treats as a real filter value.
  const definedParams = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ""),
  );
  const query = new URLSearchParams(definedParams).toString();
  return axios
    .get(`projects${query ? `?${query}` : ""}`)
    .then((res) => res.data);
}

export function createProject(payload) {
  return axios.post("projects", payload).then((res) => res.data);
}

export function getProjectById(projectId) {
  return axios.get(`projects/${projectId}`).then((res) => res.data);
}

export function updateProject({ id, formData }) {
  return axios.patch(`projects/${id}`, formData).then((res) => res.data);
}

export function deleteProject(projectId) {
  return axios.delete(`projects/${projectId}`).then((res) => res.data);
}
